import { getRequest, HandlerResponse } from "./api";
import { ObjToQueryString } from "../utility-functions/UtilityFns";
import { API_URL } from "./Environment";

export const getComapnyInfo = async (_queryParams) => {
  const queryString = ObjToQueryString(_queryParams);
  return getRequest(`${API_URL}chat/company-detail${queryString}`).then(
    (resp) => HandlerResponse(resp),
  );
};

export const getWidgetsInfo = async (_queryParams) => {
  const queryString = ObjToQueryString(_queryParams);
  return getRequest(`${API_URL}chat/get-chat-widget${queryString}`).then(
    (resp) => HandlerResponse(resp),
  );
};
